import api from '../config/api';

export default {
  getTips: (placeId, pageNumber = 1, pageSize = 100) =>
    api.get(`api/v1/places/${placeId}/tips`, {
      page_size: pageSize,
      page: pageNumber
    }),
  tipViewed: tip =>
    api.put(`api/v1/places/${tip.place_id}/tips/${tip.id}/viewed`, { tip: { like: tip.like } }),
  tipToggleLike: tip =>
    api.put(`api/v1/places/${tip.place_id}/tips/${tip.id}/viewed`, { tip: { like: !tip.like } }),
  getPlaces: () => api.get('api/v1/places')
};
